import { useEffect, useState } from "react";
import axios from "../axios";

export default function Analytics() {

  const [data, setData] = useState({
    total_campaigns: 0,
    total_sent: 0,
    total_failed: 0
  });

  const fetchAnalytics = async () => {
    try {
      const res = await axios.get("/campaigns/analytics");
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  return (
    <div className="p-6">

      <h1 className="text-3xl font-bold mb-6">Analytics Dashboard</h1>

      <div className="grid grid-cols-3 gap-6">

        <div className="bg-white p-5 rounded-xl shadow">
          <h3 className="text-gray-500">Total Campaigns</h3>
          <p className="text-2xl font-bold mt-2">{data.total_campaigns}</p>
        </div>

        <div className="bg-white p-5 rounded-xl shadow">
          <h3 className="text-gray-500">Messages Sent</h3>
          <p className="text-2xl font-bold text-green-600 mt-2">
            {data.total_sent}
          </p>
        </div>

        <div className="bg-white p-5 rounded-xl shadow">
          <h3 className="text-gray-500">Failed Messages</h3>
          <p className="text-2xl font-bold text-red-500 mt-2">
            {data.total_failed}
          </p>
        </div>

      </div>

    </div>
  );
}